import { createTheme, responsiveFontSizes } from "@mui/material";

const commonSettings = {
    typography: {
        h1: {
            fontFamily: "Outfit, serif"
        },
        h2: {
            fontFamily: "Outfit, serif"
        },
        h3: {
            fontFamily: "Outfit, serif"
        },
        h4: {
            fontFamily: "Outfit, serif"
        },
        h5: {
            fontFamily: "Outfit, serif"
        },
        h6: {
            fontFamily: "Outfit, serif"
        },
        subtitle1: {
            fontFamily: "Outfit, serif",
        },
        subtitle2: {
            fontFamily: 'Outfit, serif',
        },
        body1: {
            fontFamily: '"Josefin Sans", serif'
        },
        body2: {
            fontFamily: '"Josefin Sans", serif'
        }
    },
    opacities: [
        '1',
        '0.9',
        '0.75',
        '0.66',
        '0.5',
        '0.33',
        '0.25',
        '0.1',
    ]
}

let theme = createTheme(commonSettings);
theme = responsiveFontSizes(theme);

export default theme;